var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-profile-pfoto" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "avatar",
            expression: "display=='avatar'"
          }
        ],
        class: ["avatar-displaying", { business: _vm.business_id }],
        on: {
          click: function($event) {
            return _vm.onClick()
          }
        }
      },
      [
        _c("img", {
          ref: "avatarImg",
          attrs: { src: _vm.initImageUrl, alt: "Avatar" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "cropper-modal",
            expression: "display=='cropper-modal'"
          }
        ],
        staticClass: "cm-wrap"
      },
      [
        _c("div", { staticClass: "cm" }, [
          _c("div", { staticClass: "cm-modal-header" }, [
            _c("div", {
              staticClass: "close-btn",
              on: {
                click: function($event) {
                  return _vm.closeCropprModal()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cm-modal-body" },
            [
              _c("p", { staticClass: "bold-txt" }, [
                _vm._v("Create Profile Picture")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  'To crop this image, drag the region below and then click "Set as Profile Photo"'
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: ["UPLOADING", "UPLOADED", "COMPLETE"].includes(
                        _vm.avatar.status
                      ),
                      expression:
                        "['UPLOADING', 'UPLOADED', 'COMPLETE'].includes(avatar.status)"
                    }
                  ],
                  staticClass: "progress"
                },
                [
                  _vm._v(
                    "\n          Uploading " +
                      _vm._s(_vm.avatar.upload_percentage) +
                      "%\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("vue-cropper", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !["UPLOADING", "UPLOADED", "COMPLETE"].includes(
                      _vm.avatar.status
                    ),
                    expression:
                      "!['UPLOADING', 'UPLOADED', 'COMPLETE'].includes(avatar.status)"
                  }
                ],
                ref: "cropper",
                staticClass: "vue-cropper",
                attrs: {
                  src: _vm.avatar.url,
                  alt: "Avatar",
                  viewMode: 2,
                  aspectRatio: 1 / 1,
                  minCropBoxWidth: 50,
                  minCropBoxHeight: 50
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bold-txt upload-another",
                  on: {
                    click: function($event) {
                      return _vm.uploadAnotherImage()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-upload" }),
                  _vm._v(" \n          Upload another image?\n        ")
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cm-modal-footer" }, [
            _c(
              "div",
              {
                staticClass: "save-btn bold-txt",
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_vm._v("Set as Profile Photo")]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("input", {
      ref: "fileInput",
      staticClass: "avatar-input",
      attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
      on: {
        change: function($event) {
          return _vm.selectionProcessing($event)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }